import React, { useEffect, useState } from 'react'

import Drivers from '../../../../components/Project/Resources/Drivers/Drivers'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { DriversApi, remove as removeApi } from '../../../../api/Projects/Resources'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'

function DriversCont(props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() => DriversApi.list(project._id, 'drivers'))
  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const {
    visible,
    modalType,
    object: driver,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    removing,
    remove,
  } = useModalData(DriversApi.create, DriversApi.update, removeApi, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await DriversApi.create({ ...newObject, project })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Drivers
      {...{
        list,
        project,
        fetching,
        submitting,
        visible,
        fetch,
        driver,
        onShow,
        onCancel,
        checkForm,
        submit,
        update,
        modalType,
        formRef,
        removing,
        remove,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

DriversCont.propTypes = {}
DriversCont.defaultProps = {}

export default (DriversCont)
